import React from 'react';
import VBLeaflet from '@virkesborsen/vb-js-commons/lib/components/new/vbLeaflet';
import {FellingClassesLegend} from '../components/minskog/helpers';
import { usePropertyFetcher } from '../components/minskog/hooks/usePropertyFetcher';
import { swapCoords } from '@virkesborsen/vb-js-commons/lib/components/new/leafletConfig';
import styled from "styled-components";
import PieChart from '../components/minskog/charts/PieChart';
import BarChart from '../components/minskog/charts/BarChart';
import LineChart from '../components/minskog/charts/LineChart';

const Span = styled.span`
    border: 1px solid #ccc;
    float: left;
    width: 12px;
    height: 12px;
    margin: 2px;
    background-color: ${props => props.bgColor}; 
`

const getHeader = (prop) => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
        return <>
        <div className='d-flex justify-content-between'>
            <p className="n-fs-7">Fastighet: {prop?.designation}</p>
            <p className="n-fs-8">{formattedDate}</p>
        </div>
        <img src={`${Window.static_path}img/treebula/icon.svg`} />
        </>
    }

const getAreaAge = (sects) => {
    if(!sects){
        return []
    }
    let areaAge = new Array(11).fill(0);

    sects.forEach((sect) => {
        if(sect.age > 100) {
            areaAge[10] += parseInt(sect.area)
        } else {
            areaAge[Math.floor(sect.age / 10)] += parseInt(sect.area)
        }
    });

    return areaAge
}

const getHKLPages = (prop, hkl) => {
    if(!hkl){
        return null
    }

    let hkl_group = [[],];
    let i = 0;

    Object.keys(hkl).map((key) => {
        const hk_area = (Math.round(Number(Window.react_data.huggningsklass_area[key].ha)*10)/10)

        if(hk_area > 0){
            if(hkl_group[i].length < 8){
                hkl_group[i].push(key);
            } else{
                i+=1
                hkl_group[i] = [];
                hkl_group[i].push(key);
            }
        }
    });

    return hkl_group.map((keys) => {
        return <>
        <div className="position-relative" style={{width:"794px", height: "1123px", padding:"25px", overflow:"hidden"}}>
            <div className='container-fluid g-0'>
                {getHeader(prop)}
                <img className="vb-rounded rounded-sb" src={`${Window.static_path}img/illustration/man-with-chainsaw.jpg`} style={{ width: "100%", height:"350px", objectFit:"cover", margin:"50px 0 50px 0"}} />
                <h1 className="mb-3">Huggningsklasser</h1>
                <p className="mb-4 fw-medium">Uppskattad fördelning av olika ägoslag</p>

                <div className="row">
                    <div className="col-3">
                        <p className="text-center n-fs-6 mb-2">Huggningsklass</p>
                    </div>
                    <div className="col-3">
                        <p className="text-center n-fs-6 mb-2">Total Areal (ha)</p>
                    </div>
                    <div className="col-3">
                        <p className="text-center n-fs-6 mb-2">Total volym (m³sk)</p>
                    </div>
                    <div className="col-3">
                        <p className="text-center n-fs-6 mb-2">Nettovärde (kr)</p>
                    </div>
                </div>
                {keys.map((key) => {
                    const hk_area = (Math.round(Number(Window.react_data.huggningsklass_area[key].ha)*10)/10)
                    return <>
                    <div className="w-100" style={{height:"1px", background:"#999"}}></div>
                    <div className="row">
                        <div className="col-3">
                            <p className="text-center n-fs-7 my-1">{key}</p>
                        </div>
                        <div className="col-3">
                            <p className="text-center n-fs-7 my-1">{hk_area.toLocaleString()}</p>
                        </div>
                        <div className="col-3">
                            <p className="text-center n-fs-7 my-1">{Window.react_data.huggningsklass_area[key].volume.toLocaleString()}</p>
                        </div>
                        <div className="col-3">
                            <p className="text-center n-fs-7 my-1">{Window.react_data.huggningsklass_area[key].result.toLocaleString()}</p>
                        </div>
                    </div>
                    </>
                })}
                
            </div>
        </div>
        <div className="page-break"></div>
    </>})

}

const getSectionsPages = (prop, sects) => {
    if(!sects){
        return null
    }

    let section_group = [[],];
    let i = 0;

    sects.map((itm) => {
        if(section_group[i].length < 15){
            section_group[i].push(itm);
        } else{
            i+=1
            section_group[i] = []
            section_group[i].push(itm);
        }
    })

    return <>
    {section_group.map((sects) => {
        return <>
            <div className="position-relative" style={{width:"794px", height: "1123px", padding:"25px", overflow:"hidden"}}>
            <div className='container-fluid g-0'>
                {getHeader(prop)}
                <h1 className="my-5">Avdelningsbeskrivning</h1>
                <p className="">Sammanfattning av samtliga skapade avdelningar</p>
                <div className="row">
                    <div className="col-2">
                        <p className="text-center n-fs-6 mb-1 w-100">Avd #</p>
                    </div>
                    <div className="col-1">
                        <p className="text-center n-fs-6 mb-1 w-100">Area</p>
                    </div>
                    <div className="col-1">
                        <p className="text-center n-fs-6 mb-1 w-100">Ålder</p>
                    </div>
                    <div className="col-1">
                        <p className="text-center n-fs-6 mb-1 w-100">HKL</p>
                    </div>
                    <div className="col-1">
                        <p className="text-center n-fs-6 mb-1 w-100">SI</p>
                    </div>
                    <div className="col-2">
                        <p className="text-center n-fs-6 mb-1 w-100">Volym</p>
                    </div>
                    <div className="col-2">
                        <p className="text-center n-fs-6 mb-1 w-100">T|G|L</p>
                    </div>
                    <div className="col-2">
                        <p className="text-center n-fs-6 mb-1 w-100">Bonitet</p>
                    </div>
                </div>
                {sects.map((sect) => {
                    return <>
                    <div className="w-100 mb-1" style={{height:"1px", background:"#999"}}></div>
                    <div className="row">
                        <div className="col-2">
                            <p className="text-center n-fs-6 mb-1 w-100">{sect.localID.toLocaleString()}</p>
                        </div>
                        <div className="col-1">
                            <p className="text-center n-fs-6 mb-1 w-100">{sect.area.toLocaleString()}</p>
                        </div>
                        <div className="col-1">
                            <p className="text-center n-fs-6 mb-1 w-100">{sect.age}</p>
                        </div>
                        <div className="col-1">
                            <p className="text-center n-fs-6 mb-1 w-100">{sect.felling_class}</p>
                        </div>
                        <div className="col-1">
                            <p className="text-center n-fs-6 mb-1 w-100">{sect.si}</p>
                        </div>
                        <div className="col-2">
                            <p className="text-center n-fs-6 mb-1 w-100">{sect.volume.toLocaleString()}</p>
                        </div>
                        <div className="col-2">
                            <p className="text-center n-fs-6 mb-1 w-100">{sect.tall} | {sect.gran} | {sect.lov}</p>
                        </div>
                        <div className="col-2">
                            <p className="text-center n-fs-6 mb-1 w-100">{sect.growth_rate}</p>
                        </div>
                    </div>
                    </>
                })}
            </div>
        </div>
        <div className="page-break"></div>
        </>
    })}
    
    </>
}

const getMaps = (prop, mapCount, refs) => {
    let arr = []

    for(let i=0;i<mapCount;i++){
        arr.push(
            <>
            <div className="position-relative" style={{width:"794px", height: "1123px", padding:"25px", overflow:"hidden"}}>
                    <div className='container-fluid g-0'>
                        {getHeader(prop)}
                        <h1 className="my-5">Fastighetsrapport</h1>
                        <div className="d-flex justify-content-between mb-1">
                            <p className="m-0 fw-medium">Fastighet: </p>
                            <p className="m-0 fw-medium">{prop?.designation}</p>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <p className="m-0 fw-medium">Församling: </p>
                            <p className="m-0 fw-medium">{prop?.parish_name}</p>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <p className="m-0 fw-medium">Kommun: </p>
                            <p className="m-0 fw-medium">{prop?.muni_name}</p>
                        </div>
                        <div className="d-flex justify-content-between mb-1">
                            <p className="m-0 fw-medium">Län: </p>
                            <p className="m-0 fw-medium">{prop?.region_name}</p>
                        </div>
                        <div className="w-100" style={{height:"1px", background:"#cccccc"}}></div>
                        <div className="w-100 mt-2" style={{height:"500px"}}>
                            <VBLeaflet ref={refs[i]} className="bg-white" id={`print_map_${i}`} baseMap='Mapbox Satelite' disableAttributionControl={true}/>
                        </div>
                    </div>
                </div>
                <div className="page-break"></div>
            </>
        )
    }
    return arr
}

const setupMap = (refs, prop, i) => {
    if(refs[i]?.current?.state?.map){
        let map = refs[i]?.current?.state?.map
        const mapOptions = {showBorders: true, showSections: true, showMarkers: true, sectionOpacity: 0.5}
        
        refs[i].current.setBaseMap(null);

        let sections = L.featureGroup([])
        let borders = L.featureGroup([])
        let labels = L.featureGroup([])

        if('border' in prop) {
            prop.border.map(b => {
                let layer = L.polygon(swapCoords(b), {color: "#000000", fillOpacity: 0, interactive: false, type: 'polygon'})
                refs[i].current.setLayer(layer)
                layer.addTo(borders)
            })
        }

        prop.data.sections.map(sect => {
            const color = FellingClassesLegend[sect.felling_class] ? FellingClassesLegend[sect.felling_class].color : "#bb0000"
            const baseStyle = {
                color: "#000000",
                fillColor: color,
                opacity: 1,
                fillOpacity: 1,
                weight: 1,
                type: 'polygon'
            }
            let layer = L.polygon(swapCoords(sect.geom.coordinates), baseStyle)

            layer.baseStyle = baseStyle
            layer.data = {nr: sect.nr, localID: sect.localID, ref: prop.ref}


            const label = L.tooltip(L.latLng(sect.label_location), {
                drawn: true,
                content: `${sect.localID}`,
                className: 'black bg-transparent border-0 shadow-none n-fs-8',
                direction: "center",
                permanent: true,
                opacity: 1
            })
            
            label.addTo(labels);

            


            layer.addTo(sections)
        })

        borders.addTo(map)
        sections.addTo(map)

        labels.addTo(map)


        map.fitBounds(borders.getBounds())

        setTimeout(() => {
            window.print()
        }, 1000);
        
    } else {
        setTimeout(() => {
            setupMap(refs, prop, i)
        }, 100)
    }
}

function SBPToPdf(props) {

    const [prop, setProp] = React.useState(null);

    const [mapCount, setMapCount] = React.useState(1);

    const [showPropValue, setShowPropValue] = React.useState(true)

    const { fetchPropData } = usePropertyFetcher();

    let refs = []
    //Max amount of maps is 100
    for(let i = 0; i<100;i++){
        refs.push(React.useRef(null))
    }
    
    const setData = (d) => {
        if(d?.data){
            setProp(d)
        }
    }

    React.useEffect(() => {
        fetchPropData(setData, Window.react_data.prop)
    }, [])

    React.useEffect(() => {
        if(!prop?.ready){
            return;
        }
        let i = mapCount-1
        setupMap(refs, prop, i)
        
    }, [prop?.ready, prop, prop?.data, mapCount])


    let avg_bonn = null;
    let tot_growth = 0
    if(prop?.ready){
        let area_with_bonn = 0;
        avg_bonn = prop.data.sections.reduce((acum, curr) => {
            if(Number(curr.growth_rate) > 0){
                area_with_bonn += Number(curr.area)
            }
            return acum + Number(curr.growth_rate)
        }, 0)
        avg_bonn = Math.round((avg_bonn/prop.data.sections.length)*10)/10
        tot_growth = Math.round(area_with_bonn * avg_bonn)
    }
    
    

    return <div id="section-to-print">
        <button className="print-hide" onClick={() => {setShowPropValue(!showPropValue)}}>{showPropValue ? "Dölj fastighetsvärdering" : "Visa fastighetsvärdering"}</button>
        <div className="position-relative" style={{width:"794px", height: "1123px", margin:"0", overflow:"hidden"}}>
            <div className='container-fluid g-0'>
                <img src={`${Window.static_path}img/icons/treebula_lockup_charcoal.svg`} style={{ width: "180px", margin:"50px 0 50px 25px"}} />
                <img className="vb-rounded rounded-sb" src={`${Window.static_path}img/illustration/forest-and-sky.jpg`} style={{ width: "100%", margin:"0 0 50px 25px"}} />
                <h2 style={{marginLeft:"25px"}} className="pb-3">Fastighetsrapport</h2>
                <h3 style={{marginLeft:"25px"}} className="n-fs-4">{prop?.designation}</h3>
                <p style={{marginLeft:"25px", bottom:"15px"}} className="position-absolute n-fs-8">Treebula förbehåller sig eventuella fel och ändringar som kan ha gjorts efter att rapporten producerats</p>
            </div>
        </div>
        <div className="page-break"></div>
        <button className="print-hide" onClick={() => {setMapCount(mapCount+1)}}>Add map page</button>
        {getMaps(prop, mapCount, refs)}
        <div className="position-relative" style={{width:"794px", height: "1123px", padding:"25px", overflow:"hidden"}}>
            <div className='container-fluid g-0'>
                {getHeader(prop)}
                <h1 className="my-5 fw-medium">Sammanställning över fastigheten</h1>

                <div className="row">
                    <div className="col-6">
                        <p className="fw-medium">Arealer</p>
                    </div>
                    <div className="col-2">
                        <p className="fw-medium">Hektar</p>
                    </div>
                    <div className="col-4">
                        <p className="fw-medium">
                            Trädslagsfördelning
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        {Object.keys(Window.react_data.classified_land).map(val => <p>{val}</p>)}
                    </div>
                    <div className="col-2">
                        {Object.values(Window.react_data.classified_land).map(val => <p>{(Math.round(val*10)/10).toLocaleString()}</p>)}
                    </div>
                    <div className="col-4">
                        <p className="n-fs-6">Estimerad trädslagsfördelning</p>
                        <PieChart data={{
                            datasets: [
                                {
                                    label: 'Trädslagsfördelning',
                                    data: [(Window.react_data.tgl.tall), (Window.react_data.tgl.gran), (Window.react_data.tgl.lov)],
                                    backgroundColor: [
                                        '#00ABAC',
                                        '#A2CCB7',
                                        '#EAEEED',
                                    ],
                                    borderColor: [
                                        '#00ABAC',
                                        '#A2CCB7',
                                        '#EAEEED',
                                    ],
                                    borderWidth: 1,
                                },
                            ],
                        }} />
                        <ul className='d-flex flex-column mt-3' style={{ listStyle: "none" }}>
                            <li className='caption fw-medium'><Span bgColor="#00ABAC"></Span> &nbsp; Tall: {Window.react_data.tgl.tall} %</li>
                            <li className='caption fw-medium'><Span bgColor="#A2CCB7"></Span> &nbsp; Gran: {Window.react_data.tgl.gran} %</li>
                            <li className='caption fw-medium'><Span bgColor="#EAEEED"></Span> &nbsp; Löv: {Window.react_data.tgl.lov} %</li>
                        </ul>
                    </div>
                </div>
                <h1 className="my-3">Virkesförråd</h1>
                <div className="row">
                    <div className="col-6">
                        <div className="bg-neutral-stone py-2 px-4 rounded mb-1">
                            <p className="text-center m-0 n-fs-6">{prop?.volume?.toLocaleString()} m³sk</p>
                        </div>
                        <p className="text-center fw-medium">Totalt</p>
                    </div>
                    <div className="col-6">
                        <div className="bg-neutral-stone py-2 px-4 rounded mb-1">
                            <p className="text-center m-0 n-fs-6">{Math.round(prop?.volume/prop?.area)?.toLocaleString()} m³sk/ha</p>
                        </div>
                        <p className="text-center fw-medium">Medeltal</p>
                    </div>
                </div>
                <h1 className="my-3">Bonitet och tillväxt</h1>
                <div className="row">
                    <div className="col-6">
                        <p className="text-center n-fs-7 m-0">Fastighetens medelbonitet<br/>är beräknad till</p>
                        <div className="bg-neutral-stone py-2 px-4 rounded mt-1">
                            <p className="text-center m-0 n-fs-6 fw-medium">{avg_bonn?.toLocaleString()} m³sk/ha/år</p>
                        </div>
                        
                    </div>
                    <div className="col-6">
                        <p className="text-center n-fs-7 m-0">Tillväxt per år vid framskrivningspunkten<br/>uppskattad till cirka</p>
                        <div className="bg-neutral-stone py-2 px-4 rounded mt-1">
                            <p className="text-center m-0 n-fs-6 fw-medium">{tot_growth.toLocaleString()} m³sk</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="page-break"></div>
        <div className="position-relative" style={{width:"794px", height: "1123px", padding:"25px", overflow:"hidden"}}>
            <div className='container-fluid g-0'>
                {getHeader(prop)}
                <h1 className="my-5">Överblick</h1>
                <div className="row">
                    <div className="col-4">
                        <div className="bg-neutral-stone py-2 px-4 rounded mb-2">
                            <p className="text-center m-0 n-fs-6 fw-medium">{prop?.volume?.toLocaleString()}</p>
                        </div>
                        <p className="text-center mb-1">Totalvolym</p>
                        <p className="text-center n-fs-7">m³sk</p>
                    </div>
                    <div className="col-4">
                        <div className="bg-neutral-stone py-2 px-4 rounded mb-2">
                            <p className="text-center m-0 n-fs-6 fw-medium">{prop?.area?.toLocaleString()}</p>
                        </div>
                        <p className="text-center mb-1">Areal</p>
                        <p className="text-center n-fs-7">ha</p>
                    </div>
                    <div className="col-4">
                        <div className="bg-neutral-stone py-2 px-4 rounded mb-2">
                            <p className="text-center m-0 n-fs-6 fw-medium">{avg_bonn?.toLocaleString()}</p>
                        </div>
                        <p className="text-center mb-1">Medelbonitet</p>
                        <p className="text-center n-fs-7">m³sk/ha/år</p>
                    </div>
                </div>
            </div>
            <h1 className="my-5">Skogens fördelning på ålderklasser</h1>
            <div className='d-flex justify-content-between'>
                <div>
                    <h5 className='fw-medium'>Åldersfördelning</h5>
                    <p>Estimerad åldersfördelning</p>
                </div>

                <div>
                    <p className='caption fw-medium mb-0'>Y-axeln: Areal (ha)</p>
                    <p className='caption fw-medium mb-0'>X-axeln: Ålder</p>
                </div>
            </div>
            <BarChart 
                data={{
                    labels: ["0-10", "10-20", "20-30", "30-40", "40-50", "50-60", "60-70", "70-80", "80-90", "90-100", "100+"],
                    datasets: [
                        {
                            label: "Areal",
                            data: getAreaAge(prop?.data?.sections),
                            backgroundColor: '#A2CCB7',
                            borderSkipped: false,
                            borderWidth: 1,
                            borderRadius: 50,
                            categoryPercentage: 0.4,
                            barPercentage: 1.0
                        },
                    ],
                }}
                y={{
                    ticks: {
                        color: '#1C332A',
                        fontSize: 60,
                        fontWeight: 'bold',
                        beginAtZero: true,
                        min: 0,
                        max: 1000,
                        stepSize: 10,
                        grace: "0.005%",
                        callback: function (value, index, ticks) {
                            return value + " " + '-';
                        },
                    },
                    grid: {
                        drawBorder: false,
                        display: false,
                    },
                }} /> 
        </div>

        {showPropValue && <>
            <div className="page-break"></div>
            <div className="position-relative" style={{width:"794px", height: "1123px", padding:"25px", overflow:"hidden"}}>
                <div className='container-fluid g-0'>
                    {getHeader(prop)}
                    <h1 className="my-5">Fastighetsvärde</h1>
                    <div className="d-flex justify-content-center">
                        <div style={{paddingLeft:"50px", paddingRight:"50px"}} className="py-4 bg-neutral-stone rounded fw-medium">
                            {(Math.round(prop?.data?.prop_value?.price_m3sk * prop?.volume/1000)*1000).toLocaleString()} kr
                        </div>
                    </div>
                    <p className="n-fs-7 text-center mt-2 mb-5">(Ungefärligt fastighetsvärde beräknat på senast tillgängliga data)</p>
                    <div className="mx-5" style={{height:"1px", background:"#cccccc"}}></div>
                    <h5 className="fw-medium mb-1 mt-5">Historisk prisutveckling i kr per m³sk</h5>
                    {prop?.data?.valuation_chart_data && <LineChart data={{
                        labels: prop?.data?.valuation_chart_data?.years,
                        datasets: prop?.data?.valuation_chart_data?.line?.map((itm) => {
                            return {
                                label: "Pris",
                                data: itm.data,
                                backgroundColor: itm.color,
                                borderWidth: 4,
                                borderColor: itm.color,
                                borderCapStyle: 'butt',
                                borderDash: [],
                                borderDashOffset: 0.0,
                                borderJoinStyle: 'miter',
                                pointBorderColor: itm.color,
                                pointBackgroundColor: '#fff',
                                pointBorderWidth: 5,
                                pointRadius: 10,
                                pointHitRadius: 10,
                                pointHoverRadius: 8,
                                pointHoverBackgroundColor: '#fff',
                                pointHoverBorderColor: itm.color,
                                pointHoverBorderWidth: 5,
                            }
                        })
                    }} />}
                </div>
            </div>
        </>}
        <div className="page-break"></div>
        {getHKLPages(prop, Window.react_data.huggningsklass_area)}
        <div className="position-relative" style={{width:"794px", height: "1123px", padding:"25px", overflow:"hidden"}}>
            <div className='container-fluid g-0'>
                {getHeader(prop)}
                <h1 className="my-5">Koldioxid</h1>
                <div className="row">
                    <div className="col-6">
                        <p className="">Lagrad koldioxid baserat på virkesförråd</p>
                        <p className="fw-medium">{prop?.data?.co2_data?.co2?.toLocaleString()} ton</p>
                    </div>
                    <div className="col-6">
                        <p className="">Inlagning per år</p>
                        <p className="fw-medium">{prop?.data?.co2_data?.annual_co2_growth?.toLocaleString()} ton/år</p>
                    </div>
                </div>
                <h1 className="mt-5 mb-4">Skyddad skog</h1>
                <div className="d-flex justify-content-between" style={{width:"500px"}}>
                    <p>
                        <img style={{width:"24px"}} className="me-2" src={`${Window.static_path}img/icons/checkmark.svg`} />
                        Nyckelbiotoper
                    </p>
                    <p>{Window.react_data.nyckelbiotop_exists ? "Ja" : "Nej"}</p>
                </div>
                <div className="d-flex justify-content-between" style={{width:"500px"}}>
                    <p>
                        <img style={{width:"24px"}} className="me-2" src={`${Window.static_path}img/icons/checkmark.svg`} />
                        Förekommer objekt med naturvärden
                    </p>
                    <p>{Window.react_data.naturvarde_exists ? "Ja" : "Nej"}</p>
                </div>
                <div className="d-flex justify-content-between" style={{width:"500px"}}>
                    <p>
                        <img style={{width:"24px"}} className="me-2" src={`${Window.static_path}img/icons/checkmark.svg`} />
                        Fornlämningar
                    </p>
                    <p>{Window.react_data.heritage_exists ? "Ja" : "Nej"}</p>
                </div>
                <p className="mt-4 mb-5 n-fs-7">(Baserat på data från Skogsstyrelsen och Riksantikvarieämbetet)</p>
            </div>
            <img className="vb-rounded rounded-sb position-absolute" src={`${Window.static_path}img/illustration/river_running_through_forest_xs.jpg`} style={{width: "100%", height:"300px", objectFit:"cover", paddingLeft:"25px", right:0}} />
        </div>
        <div className="page-break"></div>
        {getSectionsPages(prop, prop?.data?.sections)}
        <div className="position-relative" style={{width:"794px", height: "1123px", overflow:"hidden"}}>
            <img src={`${Window.static_path}img/illustration/pdf-last-page.jpg`} style={{height:"100%", width:"100%", objectFit:"cover"}} />
        </div>
    </div>
}

export default SBPToPdf;